module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp2_8019.fdb77401.png";